<ng-container *ngFor="let module of receivedModules; let moduleIndex=index">
    <ng-container *ngIf="module.Layout">
        <app-form-layout-generator [moduleIndex]="moduleIndex" [layout]="module.Layout" [elements]="module.Elements" [tables]="module.Tables" [ngClass]="'form-layout-component'"></app-form-layout-generator>
    </ng-container>
</ng-container>
